import React, { useState } from 'react';
import axios from 'axios';
import './MartProductCard.css';

const MART_API_BASE = 'https://api.atrmart.in/martapi';


// Point directly to your public images folder from cPanel
const STORAGE_BASE = 'https://atrmart.in/images';

// Embedded safe placeholder (No external network dependencies)
const LOCAL_PLACEHOLDER_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 300 300"><rect width="100%" height="100%" fill="%23f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="14" fill="%239ca3af">ATR MART</text></svg>`;

const MartProductCard = ({ 
  item, 
  navigate, 
  addToCart, 
  cart, 
  user, 
  onLoginClick, 
  isInWishlist, 
  toggleWishlist 
}) => {
  const variants = (item.variants && item.variants.length > 0) 
    ? item.variants 
    : [{ size: item.unit || 'Standard', price: item.price || 0, mrp: item.mrp || 0 }];
  
  const [selectedVariant, setSelectedVariant] = useState(variants[0]);

  const cartItem = cart?.find(c => 
    (c.id === item.id) && c.selectedVariant === selectedVariant.size
  );
  const qty = cartItem ? cartItem.quantity : 0;

  const handleAdd = async (e) => {
    if (e && e.stopPropagation) e.stopPropagation(); 
    
    if (!user) {
      onLoginClick();
      return;
    }

    addToCart({
      ...item,
      selectedVariant: selectedVariant.size,
      price: selectedVariant.price
    });

    try {
      const token = localStorage.getItem('user_token'); 
      await axios.post(`${MART_API_BASE}/cart/add`, {
        product_id: item.id,
        quantity: 1,
        variant: selectedVariant.size
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
    } catch (err) {
      console.error("Mart DB Sync Error:", err);
    }
  };

  // ── EXACT AGRO IMAGE PARSING FLOW MATCHED TO CPANEL ──
  const imgUrl = (img) => {
    if (!img) return LOCAL_PLACEHOLDER_SVG;

    // If an absolute domain link is stored directly
    if (img.startsWith('http://') || img.startsWith('https://')) {
      return img;
    }

    // Clean up any stray directory prefixes if they creep into database changes later
    let cleanImgPath = img;
    if (cleanImgPath.startsWith('/')) cleanImgPath = cleanImgPath.substring(1);
    if (cleanImgPath.startsWith('public/')) cleanImgPath = cleanImgPath.replace('public/', '');
    if (cleanImgPath.startsWith('images/')) cleanImgPath = cleanImgPath.replace('images/', '');
    if (cleanImgPath.startsWith('storage/')) cleanImgPath = cleanImgPath.replace('storage/', '');

    // encodeURIComponent handles blank spaces in image names cleanly (e.g., "Andoid Smartphone.jpg")
    return `${STORAGE_BASE}/${encodeURIComponent(cleanImgPath)}`;
  };

  return (
    <div className="m-product-card" onClick={() => navigate(`/mart/product/${item.id}`)} style={{ cursor: 'pointer' }}>
      <div className="m-image-wrapper">
        <img 
          src={item.image} 
          alt={item.name} 
          className="card-main-img"
          onError={(e) => {
            // Stop loop if fallback image also fails for some reason
            if (e.target.classList.contains('img-failed')) return;
            
            e.target.onerror = null; 
            e.target.classList.add('img-failed');
            e.target.src = LOCAL_PLACEHOLDER_SVG;
          }} 
        />
        <button 
          className={`m-wishlist-btn ${isInWishlist ? 'active' : ''}`}
          onClick={(e) => { e.stopPropagation(); if(toggleWishlist) toggleWishlist(item); }}
        >
          {isInWishlist ? '❤️' : '🤍'}
        </button>
      </div>

      <div className="m-info-wrapper">
        <span className="m-category-tag">{item.category_name || 'General'}</span>
        <h3 className="m-product-title">{item.name}</h3>
        
        <div className="m-price-row">
          <span className="m-current-price">₹{selectedVariant.price}</span>
          {selectedVariant.mrp > selectedVariant.price && (
            <span className="m-old-price">₹{selectedVariant.mrp}</span>
          )}
        </div>

        {qty === 0 ? (
          <button className="m-add-to-cart-btn" onClick={handleAdd}>
            Add to Cart
          </button>
        ) : (
          <div className="m-qty-controller" onClick={e => e.stopPropagation()}>
            <button className="qty-btn">−</button>
            <span className="qty-number">{qty}</span>
            <button className="qty-btn">+</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MartProductCard;